import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "c54723ec-ab89-4b68-91e3-8f0c2a23a571", content: "It will be the same, no matter where I am.", options: {} },
  {
    id: "6dcbf866-3a96-49d9-8a8d-78a83b445684",
    content: "It will be dropping at first, and then be roughly the same.",
    options: {},
  },
  {
    id: "7748907c-f932-462c-b3de-106fdf04819b",
    content: "It will constantly drop as I move away, as if I was outside.",
    options: {},
  },
];

export const task: Task = {
  id: "8c246da0-4b0b-4c89-938d-49fe9f6c27f4",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["6dcbf866-3a96-49d9-8a8d-78a83b445684"],
};
